/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TermsOfUseItem } from './TermsOfUseItem';
import {
    TermsOfUseItemFromJSON,
    TermsOfUseItemFromJSONTyped,
    TermsOfUseItemToJSON,
    TermsOfUseItemToJSONTyped,
} from './TermsOfUseItem';

/**
 * 
 * @export
 * @interface TermsOfUseResponse
 */
export interface TermsOfUseResponse {
    /**
     * 
     * @type {Array<TermsOfUseItem>}
     * @memberof TermsOfUseResponse
     */
    termsOfUses: Array<TermsOfUseItem>;
}

/**
 * Check if a given object implements the TermsOfUseResponse interface.
 */
export function instanceOfTermsOfUseResponse(value: object): value is TermsOfUseResponse {
    if (!('termsOfUses' in value) || value['termsOfUses'] === undefined) return false;
    return true;
}

export function TermsOfUseResponseFromJSON(json: any): TermsOfUseResponse {
    return TermsOfUseResponseFromJSONTyped(json, false);
}

export function TermsOfUseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TermsOfUseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'termsOfUses': ((json['termsOfUses'] as Array<any>).map(TermsOfUseItemFromJSON)),
    };
}

export function TermsOfUseResponseToJSON(json: any): TermsOfUseResponse {
    return TermsOfUseResponseToJSONTyped(json, false);
}

export function TermsOfUseResponseToJSONTyped(value?: TermsOfUseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'termsOfUses': ((value['termsOfUses'] as Array<any>).map(TermsOfUseItemToJSON)),
    };
}

